import { AccountType, accountTypes } from 'config/user.type.constants'

export const BrokerAgreementPlaceholders: string[] = [
  'address',
  'title',
  'userCompanyName',
  'userCompanyType',
  'name',
  'email',
  'phone',
  'phoneExt',
  'brokerSSN',
  'brokerNmls',
  'todayDate',
  'companyAddress',
  'companyTitle',
  'aeName',
  'aePhone',
  'aeEmail',
  'adminSign',
  'userSign',
  'CPSoFandType',
  'signorName',
  'signorTitle',
]

export const brokerOptions = () => ({
  [AccountType.BROKER]: accountTypes[AccountType.BROKER],
  [AccountType.TABLEFUNDER]: accountTypes[AccountType.TABLEFUNDER],
  [AccountType.CORRESPONDENT]: accountTypes[AccountType.CORRESPONDENT],
  [AccountType.LOAN_OFFICER]: accountTypes[AccountType.LOAN_OFFICER],
  [AccountType.LOAN_PROCESSOR]: accountTypes[AccountType.LOAN_PROCESSOR],
  [AccountType.LOAN_OFFICER_RETAIL]: accountTypes[AccountType.LOAN_OFFICER_RETAIL],
  [AccountType.LOAN_PROCESSOR_RETAIL]: accountTypes[AccountType.LOAN_PROCESSOR_RETAIL],
  [AccountType.BRANCH]: accountTypes[AccountType.BRANCH],
})
